import APIService from "./APIService";

export default {
  async getZscore(
    competencia_de, 
    competencia_ate, 
    base, 
    show_zero_median,
    fields, 
    tipos_servicos
  ) {
    const res = await APIService.apiCall().get("zscore/get-zscore", {
      params: {
        competencia_de,
        competencia_ate,
        base,
        show_zero_median,
        fields,
        tipos_servicos
      },
    });

    return res.data;
  },
  async downloadXlsxZscore(
    competencia_de, 
    competencia_ate, 
    base, 
    show_zero_median,
    fields, 
    tipos_servicos, 
    config
  ) {
    const res = await APIService.apiCall().get("zscore/download-xlsx-zscore", {
      params: {
        competencia_de,
        competencia_ate,
        base,
        show_zero_median,
        fields,
        tipos_servicos
      },
      responseType: 'blob',  
      ...config
    });
    return res.data;
  },
};
